import React from 'react';
import type { BlockViewProps } from '@plone/types';
import { PowerBIBlockData } from './Edit';
import PowerBI from '../../PowerBI';

export const PowerBIBlockView = (
  props: BlockViewProps & {
    data: PowerBIBlockData;
  },
) => {
  return (
    <div className="block powerbi">
      <PowerBI
        data={props.data}
        block_id={props.id}
        editable={props.editable}
      />
    </div>
  );
};
